export type GetDipEnvironmentStateManagementListResponse = {
  /**
   * The results of this get_dip_environment_state_management_list response body.
   */
  dipEnvrnmntSttMngList: {
    envrnmntId: string;
    envTypeCd: string;
    dipByRgn: string;
    envrnmntIdFrom: string;
  }[];
};
